module.exports = __webpack_public_path__ + "static/media/notification-alert.594b3e07.svg";